import { createUseStyles } from 'react-jss'

import { defaultBorderRadius, zIndex8 } from '../../styles/const/common'

const useStyles = createUseStyles({
  triggerElement: {
    display: 'flex',
    cursor: 'pointer'
  },
  tooltipBody: {
    backgroundColor: ({ backgroundColor }) => backgroundColor,
    border: ({ borderColor }) => `1px solid ${borderColor}`,
    borderRadius: defaultBorderRadius,
    padding: '7px 19px',
    cursor: 'auto',
    zIndex: zIndex8,
    boxShadow: 'none',
    color: ({ color }) => color
  }
})

export default useStyles
